exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.g-recaptcha[data-v-0e0d6e88] {\n  display: inline-block;\n}\n", ""]);

// exports
